import FieldType from '../../components/Form/Fields/type'
import { emailRequired } from '@polvo-labs/form-utils'
import match from '../../components/Form/utils/match'

export interface ChangeEmailFormData {
  email: string
  email_confirmation: string
}

export type ChangeEmailForm = keyof ChangeEmailFormData

const fields: FieldType<ChangeEmailForm>[] = [
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'Email',
    },
    html: {
      placeholder: 'Digite o novo email',
    },
    validation: emailRequired,
  },
  {
    name: 'email_confirmation',
    data: {
      icon: 'mail',
      label: 'Confirmação de email',
    },
    html: {
      placeholder: 'Repita o email',
    },
    validation: {
      validate: match<ChangeEmailFormData>('email', 'Emails não batem'),
    },
  },
]

export default fields
